import {action} from 'typesafe-actions';
import {AssistantState} from './AssistantContext';
import {AssetMetaInterface, ObjectInterface, PageItem} from '@taopix/taopix-core/dist/types/types';
import {CoverMode} from '../../Assistant/Step/CreateCoverStep';

export enum AssistantActionTypes {
  SET_INIT = 'SET_INIT',
  SET_SETTINGS = 'SET_SETTINGS',
  SET_ASSETS = 'SET_ASSETS',
  ADD_COVER_ASSETS = 'ADD_COVER_ASSETS',
  SET_COVER_ASSETS = 'SET_COVER_ASSETS',
  REMOVE_COVER_ASSETS = 'REMOVE_COVER_ASSETS',
  SET_SELECTED_ASSETS = 'SET_SELECTED_ASSETS',
  REMOVE_SELECTED_ASSETS = 'REMOVE_SELECTED_ASSETS',
  UPDATE_COVER_PAGE_ITEMS = 'UPDATE_COVER_PAGE_ITEMS',
  SET_USE_ALL_PICTURES = 'SET_USE_ALL_PICTURES',
  SET_PAGE_COUNT = 'SET_PAGE_COUNT',
  SET_HISTORYID = 'SET_HISTORYID',
  INCREMENT_RUN_COUNT = 'INCREMENT_RUN_COUNT',
  SET_CHANGE_DETECTED = 'SET_CHANGE_DETECTED',
}

export const AssistantActions = {
  setInit: (payload: Partial<AssistantState>) => action(AssistantActionTypes.SET_INIT, payload),
  setSettings: (payload: ObjectInterface) => action(AssistantActionTypes.SET_SETTINGS, payload),
  setAssets: (payload: AssetMetaInterface[]) => action(AssistantActionTypes.SET_ASSETS, payload),
  addCoverAssets: (payload: {coverType: CoverMode; assets: number[]}) =>
    action(AssistantActionTypes.ADD_COVER_ASSETS, payload),
  setCoverAssets: (payload: {coverType: CoverMode; assets: number[]}) =>
    action(AssistantActionTypes.SET_COVER_ASSETS, payload),
  removeCoverAssets: (payload: {coverType: CoverMode; assets: number[]}) =>
    action(AssistantActionTypes.REMOVE_COVER_ASSETS, payload),
  setSelectedAssets: (payload: number[], clear = false) =>
    action(AssistantActionTypes.SET_SELECTED_ASSETS, {assets: payload, clear: clear}),
  removeSelectedAssets: (payload: number[]) =>
    action(AssistantActionTypes.REMOVE_SELECTED_ASSETS, payload),
  updateCoverPageItems: (payload: {
    key: 'textBox' | 'pictureBox';
    coverMode: CoverMode;
    pageItems: PageItem[] | number[];
  }) => action(AssistantActionTypes.UPDATE_COVER_PAGE_ITEMS, payload),
  setUseAllPictures: (payload: boolean) =>
    action(AssistantActionTypes.SET_USE_ALL_PICTURES, payload),
  setPageCount: (payload: {hasSet: boolean; pageCount: number}) =>
    action(AssistantActionTypes.SET_PAGE_COUNT, payload),
  setHistoryID: (historyID: number) => action(AssistantActionTypes.SET_HISTORYID, historyID),
  incrementRunCount: () => action(AssistantActionTypes.INCREMENT_RUN_COUNT, null),
  setChangeDetected: (changeDetected: boolean) =>
    action(AssistantActionTypes.SET_CHANGE_DETECTED, changeDetected),
};
